import moment from 'moment'

const paddingTimeWithZeros = (t) => {
    if (t<10)
    {
        return "0" + String(t)
    } else {
        return String(t)
    }
}

export const formatDuration = (now, end) => {
    var duration = moment.duration(end.diff(now));
    let minusSign = ""
    if (end < now)
    {
        // console.log("end > now")
        duration = moment.duration(now.diff(end));
        minusSign = "-"
    }

    //Get Days and subtract from duration
    var days = Math.floor(duration.asDays());
    duration.subtract(moment.duration(days,'days'));

    //Get hours and subtract from duration
    var hours = duration.hours();
    duration.subtract(moment.duration(hours,'hours'));

    //Get Minutes and subtract from duration
    var minutes = duration.minutes();
    duration.subtract(moment.duration(minutes,'minutes'));

    //Get seconds
    var seconds = duration.seconds();
    if (days==0)
    {
        // return paddingTimeWithZeros(hours) + ":" + paddingTimeWithZeros(minutes) + ":" + paddingTimeWithZeros(seconds) + ""
        return minusSign + hours + ":" + paddingTimeWithZeros(minutes)
    } else {
        // return days + " d " + paddingTimeWithZeros(hours) + ":" + paddingTimeWithZeros(minutes) + ":" + paddingTimeWithZeros(seconds) + ""
        return minusSign + days + " d " + hours + ":" + paddingTimeWithZeros(minutes)
    }
}

export const formatDurationForCalendar = (now, end) => {
    // Round the end to the nearest minute: for example: 10:59:59 becomes 11:00:00
    // If dates are same day, use original time difference logic
    if (now.isSame(end, 'day')) {
        const diffHours = end.diff(now, 'hours', true); // Get difference in hours as a float

        if (Math.abs(diffHours) > 4) {
            // More than 4 hours away (future or past on the same day)
            // Show "Td H:mm" using the 30-second rounding trick
            let processedEnd = end.clone().add(30, 'seconds').startOf('minute');
            const formattedTime = String(processedEnd.hour()) + ":" + paddingTimeWithZeros(processedEnd.minute());
            return "Td " + formattedTime;
        } else {
            // Within 4 hours (future or past on the same day) - show countdown
            var durationToFormat = moment.duration(end.diff(now)); // This can be negative if end is in the past
            let minusSign = "";

            if (end.isBefore(now)) { // If 'end' is before 'now'
                durationToFormat = moment.duration(now.diff(end)); // Make duration positive for component extraction
                minusSign = "-";
            }
            // If 'end' is not before 'now' (i.e., 'end' is same or after 'now'),
            // durationToFormat from end.diff(now) is already positive or zero, and minusSign remains "".

            // Get H:M components from durationToFormat (which is now effectively the absolute duration)
            var hours = durationToFormat.hours();
            var minutes = durationToFormat.minutes();

            return minusSign + hours + ":" + paddingTimeWithZeros(minutes);
        }
    } 
    // Different day cases
    else {
        let processedEnd = end.clone().add(30, 'seconds').startOf('minute');
        
        const formattedTime = processedEnd.hour() + ":" + paddingTimeWithZeros(processedEnd.minute());
        // Check if tomorrow
        if (processedEnd.isSame(now.clone().add(1, 'day'), 'day')) {
            return "Tm " + formattedTime;
        }
        // Check if within a week
        else if (processedEnd.isBefore(now.clone().add(7, 'days'))) {
            // Get abbreviated day name (like 'Th' for Thursday)
            return processedEnd.format('dd') + " " + formattedTime;
        }
        // More than a week away
        else {
            // Format as D/M with no leading zeros
            return processedEnd.format('D/M');
        }
    }
}

export default formatDuration